import React from "react";
import PropTypes from "prop-types";
import { MultiImageBlock } from "../MultiImageBlock";
// eslint-disable-next-line import/no-cycle
import { Button } from "../Button";
// eslint-disable-next-line import/no-cycle
import { ImageBannerWithContent as ImageBannerWithContentComponent } from "../../sharedComponents/ImageBannerWithContent";
import * as styles from "./ImageBannerWithContent.module.scss";

const ImageBannerWithContent = ({
	contentTitle,
	contentSubtitle,
	contentImagesBlock,
	contentButton,
	fullWidth,
}) => (
	<ImageBannerWithContentComponent
		contentTitle={contentTitle}
		contentSubtitle={contentSubtitle}
		contentImagesBlock={contentImagesBlock}
		contentButton={contentButton}
		fullWidth={fullWidth}
		customMultiImageBlock={MultiImageBlock}
		customButton={Button}
		customStyles={styles}
	/>
);

ImageBannerWithContent.propTypes = {
	contentTitle: PropTypes.string,
	contentSubtitle: PropTypes.string,
	contentImagesBlock: PropTypes.object,
	contentButton: PropTypes.object,
	fullWidth: PropTypes.bool,
};
ImageBannerWithContent.defaultProps = {
	contentTitle: null,
	contentSubtitle: null,
	contentImagesBlock: null,
	contentButton: null,
	fullWidth: false,
};

export default ImageBannerWithContent;
export { ImageBannerWithContent };
